import Vue from 'vue'
import VueI18n from 'vue-i18n'
import {
    getMaintenanceHealthStatus,
    getRetryAfterMsFromResponse,
    getRouteFullPath,
    isMaintenanceResponse
} from '~/utils/maintenance'

Vue.use(VueI18n)

export default async ({ app, store, $axios, $config }) => {

    const i18n = new VueI18n({
        locale: store.state.locale,
        fallbackLocale: 'de'
    })
    
    try {
        // Load interface strings for each locale separately to reduce response size
        // This helps avoid AWS Lambda/API Gateway size limits in production
        const locales = ['de', 'en']
        
        for (const locale of locales) {
            if (store.state.maintenance && store.state.maintenance.active) {
                i18n.setLocaleMessage(locale, {})
                continue
            }

            try {
                const data = await $axios.$get(`/interface-string/${locale}`)
                if (data[locale]) {
                    i18n.setLocaleMessage(locale, data[locale])
                }
            } catch (localeError) {
                if (
                    isMaintenanceResponse(localeError) ||
                    !localeError.response
                ) {
                    const maintenanceIsActive = Boolean(
                        store.state.maintenance &&
                        store.state.maintenance.active
                    )
                    const health = maintenanceIsActive
                        ? {
                            status: 'maintenance',
                            response: localeError.response
                        }
                        : await getMaintenanceHealthStatus(
                            $axios,
                            ($config && $config.apiVanityUrl) || ''
                        )

                    if (health.status === 'maintenance') {
                        store.dispatch('maintenance/activate', {
                            intendedRoute: getRouteFullPath(
                                app.router && app.router.currentRoute
                            ),
                            retryAfterMs: getRetryAfterMsFromResponse(
                                health.response
                            )
                        })
                    } else {
                        console.error(
                            `Failed to load ${locale} interface strings:`,
                            localeError
                        )
                    }

                    i18n.setLocaleMessage(locale, {})
                    continue
                }

                console.error(`Failed to load ${locale} interface strings:`, localeError)
                // Set empty fallback for this locale
                i18n.setLocaleMessage(locale, {})
            }
        }
    } catch (error) {
        console.error('Failed to load interface strings:', error)
        // Set minimal fallback messages to prevent complete failure
        i18n.setLocaleMessage('de', {})
        i18n.setLocaleMessage('en', {})
    }
    
    app.i18n = i18n

}
